import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var UploadIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,12l-3,0c-1.399,0 -3.005,-1.14 -3.005,-2.485c0,-1.345 1.134,-2.434 2.533,-2.434c0.101,0 0.201,0.007 0.3,0.019c-0.026,-0.171 -0.04,-0.345 -0.04,-0.521c0,-1.976 1.666,-3.579 3.724,-3.579c1.685,0 3.107,1.076 3.566,2.553c0.185,-0.031 0.374,-0.048 0.566,-0.048c1.851,0 3.351,1.443 3.351,3.223c0,1.779 -2.144,3.272 -3.995,3.272l-2,0l0,-3l2,0l-3,-3l-3,3l2,0l0,3Z"
  }));
});
UploadIcon.displayName = 'UploadIcon';
export default UploadIcon;